import React from 'react';
import { IconBaseProps } from 'react-icons';

export const CasinoIcon = (props: IconBaseProps): React.ReactElement => {
  const { size = '1em', color = 'currentColor', ...rest } = props;

  return (
    <svg
      viewBox="0 0 43 43"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      {...rest}
    >
      <g clipPath="url(#clip0_7171_51059)">
        <path
          d="M19.9043 0L23.3913 0.670195C28.0894 2.05678 31.9216 5.64543 33.6744 10.2075C33.9037 10.362 36.356 10.1671 36.9061 10.2511C37.1681 10.2914 37.625 10.619 37.625 10.876V20.6602C38.4858 20.6383 39.1972 19.9438 39.2955 19.0972L39.3097 5.5942C36.4039 4.53852 36.7364 0.650039 39.7246 0H40.5645C41.8041 0.259512 42.7413 1.1993 43 2.43555V3.35938C42.7187 4.3865 42.0048 5.24818 40.9793 5.5942L40.9743 19.2643C40.7517 20.9465 39.3425 22.2861 37.6258 22.3407L37.6275 31.9577C37.6645 32.2408 37.2345 32.7539 36.996 32.7539H34.2665V42.3701C34.2665 42.5801 33.8558 42.895 33.6786 43H3.94727C3.77006 42.895 3.35938 42.5801 3.35938 42.3701V32.7539H0.629883C0.419922 32.7539 0.10498 32.3432 0 32.166V10.834C0.10498 10.6568 0.419922 10.2461 0.629883 10.2461H3.90527C6.11322 4.59059 11.4597 0.437559 17.5872 0.0772656L17.7207 0H19.9043ZM31.8301 10.2461C30.551 7.02109 27.824 4.33779 24.6645 2.92434C17.4486 -0.303184 8.80828 2.97221 5.79492 10.2461H15.2432C15.5606 10.2461 15.8924 10.8071 15.8789 11.1262C15.8663 11.4177 15.5228 11.9258 15.2432 11.9258H1.67969V31.0742H35.9453V11.9258H22.3818C22.0644 11.9258 21.7326 11.3648 21.7461 11.0456C21.7587 10.7542 22.1022 10.2461 22.3818 10.2461H31.8301ZM39.8699 1.699C38.438 1.99295 38.8327 4.33779 40.42 4.01109C41.8519 3.71715 41.4572 1.3723 39.8699 1.699ZM32.5859 32.7539H5.03906V41.3203H32.5859V32.7539Z"
          fill="currentColor"
        />
        <path
          d="M4.00854 13.6248L33.388 13.6013C33.9078 13.6063 34.2648 13.9624 34.2698 14.4831V28.5169C34.2648 29.0367 33.9087 29.3937 33.388 29.3987H4.23698C3.73476 29.3836 3.41646 29.0972 3.35767 28.5983L3.39966 14.1908C3.49876 13.8792 3.6978 13.7146 4.00938 13.6248H4.00854ZM13.1015 15.2851H5.03903V27.7148H13.1015V15.2851ZM22.8437 15.2851H14.7812V27.7148H22.8437V15.2851ZM32.5859 15.2851H24.5234V27.7148H32.5859V15.2851Z"
          fill="currentColor"
        />
        <path
          d="M18.6227 10.2637C19.5322 10.089 20.0529 11.2102 19.2744 11.7578C18.1347 12.559 17.378 10.5022 18.6227 10.2637Z"
          fill="currentColor"
        />
        <path
          d="M9.21386 36.2148L28.5328 36.261C29.1887 36.6238 29.1879 37.4519 28.5328 37.8139H9.09208C8.38325 37.415 8.45296 36.5054 9.21386 36.2157V36.2148Z"
          fill="currentColor"
        />
        <path
          d="M7.34859 18.9805C6.56166 18.8242 6.47684 17.4998 7.36791 17.3201C7.86342 17.2201 10.1688 17.2311 10.7021 17.3058C11.5302 17.4217 11.4403 18.1633 11.2547 18.7713C10.5954 20.9339 9.5893 23.0839 8.9191 25.2541C8.38496 26.0612 7.3024 25.6866 7.32172 24.7552L9.40621 18.9796C8.8032 18.8973 7.91129 19.0913 7.34859 18.9796V18.9805Z"
          fill="currentColor"
        />
        <path
          d="M17.0908 18.9805C16.3038 18.8242 16.219 17.4998 17.1101 17.3201C17.6056 17.2201 19.911 17.2311 20.4443 17.3058C21.2724 17.4217 21.1825 18.1633 20.9969 18.7713C20.3376 20.9339 19.3315 23.0839 18.6613 25.2541C18.1271 26.0612 17.0446 25.6866 17.0639 24.7552L19.1484 18.9796C18.5454 18.8973 17.6535 19.0913 17.0908 18.9796V18.9805Z"
          fill="currentColor"
        />
        <path
          d="M26.833 18.9805C26.046 18.8242 25.9612 17.4998 26.8523 17.3201C27.3478 17.2201 29.6532 17.2311 30.1865 17.3058C31.0145 17.4217 30.9247 18.1633 30.7391 18.7713C30.0798 20.9339 29.0737 23.0839 28.4035 25.2541C27.8693 26.0612 26.7868 25.6866 26.8061 24.7552L28.8906 18.9796C28.2876 18.8973 27.3957 19.0913 26.833 18.9796V18.9805Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7171_51059">
          <rect width="43" height="43" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
